// extracted by mini-css-extract-plugin
export default {"rejectButtonBackground":"RejectButton_rejectButtonBackground__Xgo8K","buttonText":"RejectButton_buttonText__e7aJD"};